import tailwindColors from '../../../../../config/colors'
import { alphaToHex } from '../../../main/components/color-picker'

export interface BubbleSettings {
  margin: { top: number; right: number; bottom: number; left: number }
  background: string
  grid: string
  axis: {
    stroke: string
    text: string
  }
  bubble: {
    color?: string
    textShadow?: string
    stroke: string
    fill: string
  }
  color?: string
  textShadow?: string
  slider: {
    stroke: string
    highlightStroke: string
    highlight: string
    distributionHighligt: (opacity: number) => string
    distribution: (opacity: number) => string
  }
  colorPalette?: string[]
}

export const BUBBLES_SETTINGS: BubbleSettings = {
  margin: { top: 20, right: 25, bottom: 30, left: 50 },
  background: tailwindColors.finviz['blue-gray'],
  grid: '#8a95b126',
  axis: {
    stroke: '#8a95b1',
    text: '#8a95b1',
  },
  bubble: {
    textShadow: '#0006',
    stroke: 'rgba(255,255,255,0.25)',
    fill: 'rgba(255,255,255,0.1)',
  },
  textShadow: '#000000b3',
  slider: {
    stroke: '#404553',
    highlightStroke: '#ffd61480',
    highlight: '#ffd61426',
    distributionHighligt: (opacity) => `#ffd614${alphaToHex(opacity)}`,
    distribution: (opacity) => `#ffffff${alphaToHex(opacity)}`,
  },
}
